import { systemColors } from "../system";

const functional = {
  info: systemColors["sys-lavender"][800],
  destructive: systemColors["sys-coral"][800],
  success: systemColors["sys-olive"][800],
  warning: systemColors["sys-marmalade"][800],
  benefit: systemColors["sys-green"][800],
  reassurance: systemColors["sys-blue"][600],
};

const state = {
  loading: {
    DEFAULT: systemColors["sys-grey"][500],
  },
};

const foreground = {
  inverse: systemColors["sys-white"],
  DEFAULT: systemColors["sys-black"][850],
  "link-text": systemColors["sys-blue"][800],
  muted: systemColors["sys-grey"][500],
  "muted-strong": systemColors["sys-grey"][600],
  subtle: systemColors["sys-grey"][50],
};

export const textColor = {
  functional,
  state,
  foreground,
};
